import { EXPLORER_URL } from "../../../utils/constant";
import {
  ActionFailModal,
  ActionFinalizeModal,
  ActionSuccessModal
} from "./index";

export default function ModalManager({
  modalType,
  show,
  handleClose,
  value,
  tokenSymbol,
  tokenPrice,
  rewardsFormatted,
  confirmStake,
  confirmUnstake,
  confirmClaimRewards,
  confirmClaimAndRestake,
  feeRate,
  ethPrice,
  txHash,
  availableStakes = {},
}) {
  if (!show) return null;

  switch (modalType) {
    case "stakeFinalize":
      return (
        <ActionFinalizeModal
          show={show}
          handleClose={handleClose}
          title="Finalize Stake"
          label="Stake Amount"
          noteTitle=""
          noteDesc=""
          value={value}
          tokenSymbol={tokenSymbol}
          tokenPrice={tokenPrice}
          confirmAction={confirmStake}
          feeRate={feeRate}
          ethPrice={ethPrice}// 0.5% stake fee
        />

      );

    case "unstakeFinalize":
      return (
        <ActionFinalizeModal
          show={show}
          handleClose={handleClose}
          title="Finalize Unstake"
          label="Staked Amount"
          noteTitle="Cooldown period"
          noteDesc="After unstaking, you will be able to withdraw your tokens in 7 days"
          value={value}
          tokenSymbol={tokenSymbol}
          tokenPrice={tokenPrice}
          confirmAction={confirmUnstake}
          feeRate={feeRate}
          availableStakes={availableStakes}
        />
      );

    case "claimFinalize":
      return (
        <ActionFinalizeModal
          show={show}
          handleClose={handleClose}
          title="Finalize Claim"
          label="Claimable Reward"
          noteTitle="Lockup Period"
          noteDesc="Claiming your rewards will reset your lockup period to 90 days"
          value={rewardsFormatted}
          tokenSymbol={tokenSymbol}
          tokenPrice={tokenPrice}
          confirmAction={confirmClaimRewards}
          feeRate={feeRate}
          ethPrice={ethPrice}
        />
      );

    case "stakeSuccess":
      return (
        <ActionSuccessModal
          show={show}
          handleClose={handleClose}
          heading="Stake Successful!"
          message={<>
            You’ve staked <strong className="strongetext">{value}  {tokenSymbol}</strong> in this pool. Rewards will start accruing immediately.
          </>}
          noteTitle=""
          noteDesc=""
          amount={value}
          tokenSymbol={tokenSymbol}
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      );

    case "unstakeSuccess":
      return (
        <ActionSuccessModal
          show={show}
          handleClose={handleClose}
          heading="Unstake Successful!"
          message={`You’ve successfully unstaked ${value} ${tokenSymbol} from this pool.`}
          noteTitle="Cooldown period"
          noteDesc="You will be able to withdraw your tokens in 7 days"
          amount={value}
          tokenSymbol={tokenSymbol}
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      );

    case "claimSuccess":
      return (
        <ActionSuccessModal
          show={show}
          handleClose={handleClose}
          heading="Rewards Claimed Successfully!"
          message={`You’ve claimed ${rewardsFormatted} ${tokenSymbol} from this pool.`}
          noteTitle=""
          noteDesc=""
          amount={rewardsFormatted}
          tokenSymbol={tokenSymbol}
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      );

    case "stakeFail":
      return (
        <ActionFailModal
          show={show}
          handleClose={handleClose}
          heading="Stake Failed"
          message="Your stake could not be completed. Please try again or check your wallet for details."
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      );

    case "unstakeFail":
      return (
        <ActionFailModal
          show={show}
          handleClose={handleClose}
          heading="Unstake Failed"
          message="Your unstake could not be completed. Please try again or check your wallet for details."
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      );

    case "claimFail":
      return (
        <ActionFailModal
          show={show}
          handleClose={handleClose}
          heading="Claim Failed"
          message="Your reward claim could not be completed. Please try again or check your wallet for details."
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      ); 
      
    case "restakeFinalize":
      return (
        <ActionFinalizeModal
          show={show}
          handleClose={handleClose}
          title="Finalize Restake"
          label="Restake Amount"
          noteTitle="Lockup Period"
          noteDesc="Restaking your rewards will reset your lockup period to 90 days"
          value={rewardsFormatted}
          tokenSymbol={tokenSymbol}
          tokenPrice={tokenPrice}
          confirmAction={confirmClaimAndRestake}
          feeRate={feeRate}
          ethPrice={ethPrice}
        />
      );

    case "restakeSuccess":
      return (
        <ActionSuccessModal
          show={show}
          handleClose={handleClose}
          heading="Restake Successful!"
          message={`You’ve successfully restaked ${rewardsFormatted} ${tokenSymbol} back into the pool.`}
          noteTitle="Cooldown Period"
          noteDesc="You will be able to withdraw your tokens in 90 days"
          amount={rewardsFormatted}
          tokenSymbol={tokenSymbol}
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      );

    case "restakeFail":
      return (
        <ActionFailModal
          show={show}
          handleClose={handleClose}
          heading="Restake Failed"
          message="Your restake could not be completed. Please try again or check your wallet for details."
          txHash={txHash}
          viewTx={`${EXPLORER_URL}${txHash}`}
        />
      );



    default:
      return null;
  }
}
